import { BootstrapToolTip } from '@/_elements/ToolTip';
import { fetchWrapper } from '@/_helpers';
import React, { useEffect, useState } from 'react';
import { BsStarFill, BsStar } from 'react-icons/bs';
import { VscLoading } from 'react-icons/vsc';
import { toast } from 'react-toastify';
import { css } from 'twin.macro';

const StarUserFormData = ({ userFormData, handleUpdate = () => {} }) => {
    const initialStarred = Boolean(userFormData?.isStarred);
    const [starredLocally, setStarredLocally] = useState(initialStarred);
    const [isUpdating, setIsUpdating] = useState(false);

    useEffect(() => {
        setStarredLocally(Boolean(userFormData?.isStarred));
    }, [userFormData]);

    const handleStar = async () => {
        const userFormDataId = userFormData?._id;
        if (!userFormDataId || isUpdating) {
            return;
        }

        const currentlyStarred = starredLocally;
        setIsUpdating(true);
        try {
            const endpoint = `userFormData/${userFormDataId}/stars${currentlyStarred ? '?remove=true' : ''}`;
            const response = await fetchWrapper.put(endpoint, {});
            const nextStarred = typeof response?.isStarred === 'boolean' ? response.isStarred : !currentlyStarred;
            const updatedForm = {
                ...userFormData,
                ...(response || {}),
                isStarred: nextStarred,
            };

            setStarredLocally(nextStarred);
            handleUpdate(updatedForm);
        } catch (err) {
            toast.error(err?.message || 'Failed to update star. Please try again.');
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <BootstrapToolTip text={starredLocally ? 'Unstar submission' : 'Star submission'}>
            <div
                onClick={handleStar}
                css={css`
                    cursor: pointer;
                    align-items: center;
                    justify-content: center;
                    margin-left: 0.5rem;
                    opacity: ${isUpdating ? 0.25 : 1};
                    pointer-events: ${isUpdating ? 'none' : 'auto'};
                    svg {
                        color: ${starredLocally ? '#ffc107' : '#50aeb0'};
                    }
                    :hover svg {
                        color: #ffc107;
                    }
                `}
                className="dropper star-icon mx-2"
                aria-busy={isUpdating}
                aria-disabled={isUpdating}
                title={starredLocally ? 'Unstar submission' : 'Star submission'}
            >
                {isUpdating ? (
                    <VscLoading size={20} className="spin" />
                ) : starredLocally ? (
                    <BsStarFill size={22} />
                ) : (
                    <BsStar size={22} />
                )}
            </div>
        </BootstrapToolTip>
    );
};
export default StarUserFormData;
